declare const SERVER_URL: string;

export const config = {
    serverUrl: SERVER_URL
};
